document.addEventListener("click", function(e) {

  const button = e.target.closest(".richtext-readmore-btn");
  if (!button) return;

  const wrapper = button.closest(".richtext-readmore-wrapper");
  const content = wrapper.querySelector(".richtext-readmore-content");

  content.classList.toggle("is-collapsed");

  button.textContent = content.classList.contains("is-collapsed")
    ? wrapper.dataset.readMore
    : wrapper.dataset.readLess;
});